module.exports = __webpack_public_path__ + "images/amazon-aplus-46c167ec.svg";